module.exports = "/_next/static/images/58e2a67c3317a50c49a96b38bf70edd5-woman-holding-card-smiling-2@tablet768.png";